import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { useNavigate } from "react-router-dom";
import { getContactListing, deleteContactUs } from "../../api/apiHandler";
import { showMessage, showErrorMessage, convertUTCToLocal } from "../common/Utils";
import $ from 'jquery';
import 'magnific-popup';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import 'select2';
import 'select2/dist/css/select2.min.css';
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import HtmlContent from '../../components/htmlcontent/HtmlContent';

export function Contactus() {

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#B6A878',
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '14px',
                textAlign: 'center',
                padding: '10px',
            },
        },
        cells: {
            style: {
                padding: '8px',
                textAlign: 'center',
                borderBottom: '1px solid #e0e0e0',
            },
        },
    };

    let navigate = useNavigate();
    const auth = localStorage.getItem('token');
    const timezone = localStorage.getItem('timezone');

    // Redirect to login if not logged in
    if (!auth) {
        navigate('/login');
    }

    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [pagination, setPagination] = useState({ page: 1, perPage: 50 });
    const [sortField, setSortField] = useState("id");
    const [sortOrder, setSortOrder] = useState("DESC");
    const [showModal, setShowModal] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState({});
    
    // Fetch data from server
    const fetchData = async () => {
        setLoading(true);
        try {
            
            const userReq = {
                page: pagination.page,
                per_page: pagination.perPage,
                search,
                sort: sortField,
                order: sortOrder,
            }
            const response = await getContactListing(userReq);
            if (parseInt(response.code) === 1) {
                setData(response.data.items);
                setTotalRows(response.data.totalcount);
            } else {
                showErrorMessage(response.message);
            }
        } catch (error) {
            showErrorMessage("Something went wrong loading contact us, please try again later");
        }
        setLoading(false);
    };

    useEffect(() => {
        $('.image-popup').magnificPopup({
            type: 'image',
            gallery: {
              enabled: true
            }
        });
        fetchData();
    }, [pagination, search, sortField, sortOrder]);
    
    // Handle pagination
    const handlePageChange = (page) => {
        setPagination((prev) => ({ ...prev, page }));
    };
    
    const handlePerRowsChange = (perPage) => {
        setPagination({ page: 1, perPage });
    };
    
      // Handle sorting
    const handleSort = (column, sortDirection) => {
        setSortField(column.sortableField); // Field to sort by
        setSortOrder(sortDirection.toUpperCase()); // ASC or DESC
    };

    const showDeleteConfirmation = async (contact_id) => {
        try {
            // Show confirmation dialog
            const result = await Swal.fire({
                title: "",
                text: "Are you sure you want to delete this contact us? It can't be reverted back!",
                imageUrl: process.env.PUBLIC_URL + '/logo.png',
                imageSize: '80x80',
                showCancelButton: true,
                confirmButtonColor: "#B6A878",
                cancelButtonColor: "#d33",
                confirmButtonText: "Confirm",
            });
            
            if (result.isConfirmed) {

                const updUsers = {
                    is_deleted: true,
                    contact_id: contact_id
                }

                const response = await deleteContactUs(updUsers);
                if (parseInt(response.code) === 1) {
                    showMessage(response.message);
                    fetchData();
                } else {
                    showErrorMessage(response.message);
                }
            }
        } catch (error) {
            showErrorMessage("An unexpected error occurred deleting record!");
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Contact Us</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Contact Us</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="body">
                                    <div className="table-responsive">
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <div></div>
                                            <div style={{ position: "relative", maxWidth: "300px" }}>
                                                <input
                                                    type="text"
                                                    placeholder="🔍 Search..."
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        padding: "10px 15px",
                                                        borderRadius: "25px",
                                                        border: "1px solid #ccc",
                                                        outline: "none",
                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                        fontSize: "14px",
                                                    }}
                                                    className="form-control mb-3"
                                                />
                                            </div>
                                        </div>
                                        <DataTable
                                            columns={[
                                                { name: "ID", selector: (row) => row.id, sortable: true, sortableField: 'id', width: '5%' },
                                                { name: "FIRST NAME", selector: (row) => row.first_name, sortable: true, sortableField: "first_name", width: '12%' },
                                                { name: "LAST NAME", selector: (row) => row.last_name, sortable: true, sortableField: "last_name", width: '10%' },
                                                { name: "EMAIL", selector: (row) => row.email, sortable: false, width: '12%' },
                                                { name: "SUBJECT", selector: (row) => row.subject, sortable: false, width: '10%' },
                                                { name: "MESSAGE", selector: (row) => row.message, sortable: false, width: '12%' },
                                                { name: "REPLIED?", selector: (row) => row.is_replied === 1 ? <label class="label label-success">Yes</label> : <label class="label label-danger">No</label>, sortable: false, width: '8%' },
                                                { name: "REPLY MESSAGE", selector: (row) => { 
                                                    if (row.is_replied === 1) {
                                                        return <a
                                                            href={ "#" }
                                                            className="btn btn-xs waves-effect waves-float waves-green"
                                                            onClick={() => {
                                                                setSelectedMessage(row);
                                                                setShowModal(true);
                                                            }}
                                                            style={{ marginBottom: '1px', border: '1px solid #D7C9A1' }}
                                                        >View Message</a>
                                                    } else {
                                                        return "NA"
                                                    }
                                                }, sortable: false, width: '15%' },
                                                { name: "CREATED AT", selector: (row) => convertUTCToLocal(row.created_at, timezone), sortable: true, sortableField: "created_at", width: '14%' },
                                                { 
                                                    name: "ACTIONS", 
                                                    selector: (row) => (
                                                        <>
                                                            {row.is_replied === 1 ? 
                                                                <a
                                                                    href="#"
                                                                    onClick={() => showDeleteConfirmation(row.id)}
                                                                    className="btn btn-xs waves-effect waves-float waves-green"
                                                                    style={{ marginBottom: '1px', border: '1px solid #D7C9A1' }}
                                                                >
                                                                    <i className="zmdi zmdi-delete" style={{ color: '#D7C9A1' }} />
                                                                </a> : ''
                                                            }
                                                            &nbsp;
                                                            {row.is_replied === 0 ? 
                                                                <a
                                                                    href={ `/authpanel/contactus/reply-message/${btoa(row.id)}` }
                                                                    className="btn btn-xs waves-effect waves-float waves-green"
                                                                    style={{ marginBottom: '1px', border: '1px solid #D7C9A1' }}
                                                                >
                                                                    <i className="zmdi zmdi-mail-reply" style={{ color: '#D7C9A1' }} />
                                                                </a> : ''
                                                            }
                                                            &nbsp;
                                                            {
                                                                <a
                                                                    href={ "#" }
                                                                    className="btn btn-xs waves-effect waves-float waves-green"
                                                                    onClick={() => {
                                                                        setSelectedMessage(row);
                                                                        setShowModal(true);
                                                                    }}
                                                                    style={{ marginBottom: '1px', border: '1px solid #D7C9A1' }}
                                                                >
                                                                    <i className="zmdi zmdi-eye" style={{ color: '#D7C9A1' }} />
                                                                </a>
                                                            }
                                                        </>
                                                    ),
                                                    sortable: false,
                                                    width: '10%'
                                                },
                                            ]}
                                            data={data || []}
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                            paginationPerPage={50} // Default page size
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            onSort={handleSort}
                                            sortServer
                                            persistTableHead
                                            progressPending={loading}
                                            customStyles={customStyles}
                                            noDataComponent={<div style={{ textAlign: "center", padding: "20px", color: "#888" }}>No data found</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <MessageModal
                timezone={timezone}
                row={selectedMessage}
                isOpen={showModal}
                onClose={() => setShowModal(false)}
            />
        </>
    );
}

const MessageModal = ({ timezone, row, isOpen, onClose }) => {
    if (!isOpen) return null;
    return (
        <div className="modal-backdrop show" style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 1050,
        }}>
            <div className="modal-content" style={{
                background: "#fff",
                borderRadius: "8px",
                padding: "20px",
                maxWidth: "600px",
                width: "90%",
                maxHeight: "80vh",
                overflowY: "auto",
                position: "relative",
                boxShadow: "0px 5px 15px rgba(0,0,0,0.3)"
            }}>
                <button onClick={onClose} style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    border: "none",
                    background: "transparent",
                    fontSize: "20px",
                    cursor: "pointer"
                }}>&times;</button>
                <h5>Message details</h5>
                <hr />
                <div className="row">
                    <div className="col-md-6">
                        <div className="about-info-p">
                            <strong>First Name</strong> <br />
                            <p className="text-muted">{row.first_name}</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="about-info-p">
                            <strong>Last Name</strong> <br />
                            <p className="text-muted">{row.last_name}</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="about-info-p">
                            <strong>Email</strong> <br />
                            <p className="text-muted">{row.email}</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="about-info-p">
                            <strong>Subject</strong> <br />
                            <p className="text-muted">{row.subject}</p>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="about-info-p">
                            <strong>Message</strong> <br />
                            <p className="text-muted">{row.message}</p>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="about-info-p">
                            <strong>Reply Message</strong> <br />
                            <p className="text-muted"><HtmlContent html={row.reply_message} /></p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="about-info-p">
                            <strong>Created At</strong> <br />
                            <p className="text-muted">{convertUTCToLocal(row.created_at, timezone)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};